module.exports = __webpack_public_path__ + "fonts/fast.svg?a8bfbaac";